import { render, staticRenderFns } from "./ordiniInviati.html?vue&type=template&id=1963c5d2&scoped=true&"
import script from "./OrdiniInviati.vue?vue&type=script&lang=js&"
export * from "./OrdiniInviati.vue?vue&type=script&lang=js&"
import style0 from "./OrdiniInviati.vue?vue&type=style&index=0&id=1963c5d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1963c5d2",
  null
  
)

export default component.exports